// @flow
import { connect } from 'react-redux';

import SimilarContentCard from 'components/fragments/card/SimilarContentCard';
import type { StateProps } from 'components/fragments/card/SimilarContentCard';
import type { StateType } from 'types/Actions';

export default connect((state: StateType): StateProps => ({
  userPref: state.userState.userPref
}))(SimilarContentCard);
